module.exports = __webpack_public_path__ + "953ea5dd9337638320fc2089023814b1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo.svg
// module id = 279
// module chunks = 0